import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative py-4 px-4 md:px-0 w-full bg-grey-lighten-1"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "d-flex justify-end buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": "",
    persistent: "",
    "max-width": "480px",
    class: "dialog",
    "onClick:outside": _ctx.onCancelClicked
  }, {
    default: _withCtx(() => [
      (_ctx.confirmation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-h6 text-grey-darken-2 mb-2" }, " Are you sure? ", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                textContent: _toDisplayString(_ctx.confirmation.message)
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_btn, {
                  class: "mr-2 bg-grey-lighten-1",
                  onClick: _withModifiers(_ctx.onCancelClicked, ["stop"])
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("No", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  class: "mr-2",
                  color: "primary",
                  onClick: _withModifiers(_ctx.onYesClicked, ["stop"])
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Yes", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClick:outside"]))
}